import { render, staticRenderFns } from "./MyViolation.vue?vue&type=template&id=affd2b40&scoped=true"
import script from "./MyViolation.vue?vue&type=script&lang=js"
export * from "./MyViolation.vue?vue&type=script&lang=js"
import style0 from "./MyViolation.vue?vue&type=style&index=0&id=affd2b40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affd2b40",
  null
  
)

export default component.exports